import React from 'react';
import { equiteeLogo } from '../../assets';

const LogoSection: React.FC = () => (
  <section className="bg-[#F8FAFC] w-full sm:w-3/5 py-8 sm:py-0 h-auto sm:h-full flex flex-col justify-center font-['Plus Jakarta Sans']">
    <div>
      <div className="flex flex-col items-center px-4 sm:px-0">
        <div className="flex items-center gap-2 sm:gap-3 mb-4 sm:mb-8">
          <img
            src={equiteeLogo}
            alt="Equitee"
            className="object-contain w-[70px] sm:w-[100px]"
          />
          <span className="text-[24px] sm:text-[30px] font-bold text-[#333333]">Edge</span>
        </div>
        {/* <h2 className="text-2xl sm:text-4xl font-bold text-[#333333] mb-2 tracking-wide text-center">EQUITEE EDGE</h2> */}
        <h6 className="text-lg sm:text-2xl font-light text-[#6741c6] text-center px-2">Democratising access to private markets</h6>
      </div>
    </div>
  </section>
);

export default LogoSection;